import { render, staticRenderFns } from "./porposal-confirmation.vue?vue&type=template&id=2cc6042e&scoped=true&"
import script from "./porposal-confirmation.vue?vue&type=script&lang=ts&"
export * from "./porposal-confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-confirmation.vue?vue&type=style&index=0&id=2cc6042e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6042e",
  null
  
)

export default component.exports